import ctl from '@netlify/classnames-template-literals';

export const buttonsContainerStyle = ctl(`
  flex 
  justify-end 
  mt-10 
  gap-1
`);

export const confirmButtonClasses = {
  container: 'bg-green-ncs',
};

export const cancelButtonClasses = {
  container: 'bg-inherit',
  text: 'text-waterspout',
};

export const iconStyle = ctl(`
  mr-2
  mt-[2px]
  text-xl
`);
